export default {
    PARTICIPANT_TABLE_HEADER: "Participants",
    PARTICIPANT_TABLE_NO_CONTENT_HEADER: "No Participants",
    PARTICIPANT_TABLE_NO_CONTENT_BODY: "You have not added any participant.",
    PARTICIPANT_TABLE_NO_MATCH_HEADER: "No Matches",
    PARTICIPANT_TABLE_NO_MATCH_BODY: "We can't find a match.",
    QUESTIONNAIRE_TABLE_HEADER: "View Questionnaires",
    QUESTIONNAIRE_TABLE_NO_CONTENT_HEADER: "No Questionnaires",
    QUESTIONNAIRE_TABLE_NO_CONTENT_BODY: "No questionnaires assigned. If you think there should be a questionnaire here, please make sure the email used to assign the questionnaire matches exactly to your login email",
}